import { getRouteUrl } from '@nackle/service-urls';

export const idURL = getRouteUrl( 'ID_PROVIDER' );
export const emailURL = getRouteUrl( 'EMAIL_SERVICE_V1' );
